import { Component, Event, EventEmitter, h, Host, Prop, State, Watch } from '@stencil/core'

import { colors } from '../../tailwind'
import { classes } from '../../utils/css'
import { loadScript } from '../../utils/resource'

declare global {
  interface Window {
    _wq: any[]
  }
}

@Component({
  tag: 'ui-guided-walkthrough',
})
export class UiGuidedWalkthrough {
  @Prop() guidedWalkthroughWistiaId: string

  @Event() completed: EventEmitter

  @State() isConfirmed = false

  videoApi: any

  @Watch('isConfirmed')
  onConfirm() {
    this.videoApi.play()
  }

  async componentWillLoad() {
    await loadScript('//fast.wistia.com/assets/external/E-v1.js')
  }

  async componentDidLoad() {
    let playing = false
    this.videoApi = await new Promise((resolve) => {
      window._wq.push({
        id: this.guidedWalkthroughWistiaId,
        options: {
          seo: false,
          resumable: false,
          playerColor: colors['surface-base'],
        },
        onReady: (video) => {
          video.bind('play', () => {
            if (!playing) {
              this.isConfirmed = true
            }
            playing = true
          })
          resolve(video)
        },
      })
    })
  }

  render() {
    return (
      <Host class='group fixed top-0 left-0 z-menu w-screen h-screen pointer-events-none'>
        <button
          class={`
            cursor-pointer absolute transition duration-200 flex items-center justify-center w-full h-full bg-surface-base
            ${classes(this.isConfirmed, 'opacity-0 pointer-events-none', 'pointer-events-auto')}
          `}
          style={{ '--tw-bg-opacity': '0.85' }}
          onClick={() => {
            this.completed.emit()
            this.videoApi.play()
          }}
        >
          <h1 class='flex items-center py-2 pr-4 pl-2 text-lg font-extrabold leading-none text-link group-hover:text-surface-base uppercase bg-link bg-opacity-0 group-hover:bg-opacity-100 rounded-full border-2 border-link transition duration-200'>
            <ui-icon icon='play' class='mr-1 text-4xl leading-none' />
            Continue tutorial
          </h1>
        </button>
        <div
          class={`
            pointer-events-auto transform transition duration-300 ease-out absolute bottom-12 right-0 wistia_embed wistia_async_${
              this.guidedWalkthroughWistiaId
            }
            ${classes(this.isConfirmed, 'translate-y-0', 'translate-y-full')}
          `}
          style={{ width: '400px', height: '225px' }}
        />
      </Host>
    )
  }
}
